<script lang="ts">
	import Menu from '$lib/components/fragments/Menu.svelte';
	import Wordmark from '$lib/components/fragments/Wordmark.svelte';
	import LanguageSelector from '$lib/components/fragments/LanguageSelector.svelte';
	import { page } from '$app/state';

	let minScrollY = $state(0);
	let prevScrollY = $state(0);
	let currentScrollY = $state(0);
	let maxScrollY = $state(0);
	let scrollDirection = $state<'up' | 'down'>('down');

	$effect(() => {
		scrollDirection =
			currentScrollY > prevScrollY ? 'down' : currentScrollY < prevScrollY ? 'up' : scrollDirection;
		prevScrollY = currentScrollY;

		if (currentScrollY > maxScrollY) {
			maxScrollY = currentScrollY;
		} else if (currentScrollY < minScrollY) {
			minScrollY = currentScrollY;
		}
	});

	$effect(() => {
		if (scrollDirection === 'down') {
			maxScrollY = currentScrollY;
		} else if (scrollDirection === 'up') {
			minScrollY = currentScrollY;
		}
	});

	let visible = $derived(
		(scrollDirection === 'up' && maxScrollY - minScrollY > 100) ||
			(scrollDirection === 'down' && maxScrollY - minScrollY < 10) ||
			currentScrollY < 100
	);
</script>

<svelte:window bind:scrollY={currentScrollY} />

<header
	class={[
		'bg-blue/90 fixed inset-x-0 top-0 z-50 py-3 shadow-sm backdrop-blur-sm transition-all',
		visible ? 'translate-y-0' : '-translate-y-full opacity-0'
	]}
>
	<div class="content-well-lg flex items-center justify-between">
		<a
			href={page.data.publisher_url}
			title={page.data.publisher}
			class="w-26 text-white md:w-32"
			target="_blank"
			rel="noopener noreferrer"
		>
			<Wordmark />
		</a>
		<div class="flex items-center gap-2">
			<LanguageSelector />
			<Menu />
		</div>
	</div>
</header>
